export interface LijstParitaireComites
{
    nummer: string,
    benaming:string
}
export const lijstParitaireComites : LijstParitaireComites[] = [
    {nummer:'100',benaming:'werklieden (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'101',benaming:'Nationale Gemengde Mijncommissie'},
    {nummer:'102',benaming:'Groefbedrijf'},
    {nummer:'102.01',benaming:'Hardsteen -en kalksteengroev. in Henegouwen'},
    {nummer:'102.02',benaming:'Hardsteen -en kalksteengroev. in Luik en Namen'},
    {nummer:'102.03',benaming:'Porfiergroev. in Wls-Brabant/Henegouwen + kwartsietgroeven in Wls-Brabant'},
    {nummer:'102.04',benaming:'Zandsteen- en kwartsietgroev., uitgz. kwartsietgroeven van Wls-Brabant'},
    {nummer:'102.05',benaming:'Porselein-aarde- en zandgroev. Wls-Brabant, Henegouwen, Luik, Lux en Namen'},
    {nummer:'102.06',benaming:'Grint- en zandgroev. in Antwerpen, W-Vl, O-Vl, Limburg en Vl-Brabant'},
    {nummer:'102.07',benaming:'Kalksteen-groeven,cementfabrieken en kalkovens van Doornik'},
    {nummer:'102.08',benaming:'Marmer-groeven en –zagerijen op het gehele grondgebied van het Rijk'},
    {nummer:'102.09',benaming:'Groeven van kalksteen en kalkovens, van de bitterspaatgroev. en –ovens'},
    {nummer:'102.10',benaming:'terugwinning van steenstort (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'102.11',benaming:'leisteen -en coticulegroeven, groeven van slijpsteen vr scheermessen in Wls-Brabant, Heneg., Luik, Lux en Namen'},
    {nummer:'104',benaming:'Ijzernijverheid'},
    {nummer:'105',benaming:'Non-ferro metalen '},
    {nummer:'106',benaming:'cementbedrijf '},
    {nummer:'106.01',benaming:'Cementfabrieken'},
    {nummer:'106.02',benaming:'Betonindustrie'},
    {nummer:'106.03',benaming:'Vezelcement '},
    {nummer:'107',benaming:'Meester-kleermakers, de kleermaaksters en naaisters'},
    {nummer:'109',benaming:'Kleding- en confectiebedrijf'},
    {nummer:'110',benaming:'Textielverzorging'},
    {nummer:'111',benaming:'Metaal-, machine- en elektrische bouw'},
    {nummer:'112',benaming:'Garagebedrijf'},
    {nummer:'113',benaming:'Ceramiekbedrijf '},
    {nummer:'113.01',benaming:'faience -en het porseleinbedrijf, de sainitaire artikelen en de schuurproducten'},
    {nummer:'113.02',benaming:'ceramiebekleding en vloertegels'},
    {nummer:'113.03',benaming:'vuurvaste producten'},
    {nummer:'113.04',benaming:'Pannenbakkerijen'},
    {nummer:'114',benaming:'Steenbakkerij '},
    {nummer:'114.01',benaming:'steenbakkerij in Oost- en West-Vlaanderen'},
    {nummer:'114.02',benaming:'Steenbakkerij in Antwerpen'},
    {nummer:'114.03',benaming:'Steenbakkerij in Limburg en Vlaams-Brabant'},
    {nummer:'114.04',benaming:'Steenbakkerij in Luik, Lux., Namen, Henegouwen en Wls-Brabant'},
    {nummer:'115',benaming:'Het glasbedrijf'},
    {nummer:'116',benaming:'Scheikundige nijverheid '},
    {nummer:'117',benaming:'petroleumnijverheid en -handel'},
    {nummer:'118',benaming:'Voedingsnijverheid'},
    {nummer:'119',benaming:'Handel in voedingswaren'},
    {nummer:'120',benaming:'Textielnijverheid en het breiwerk'},
    {nummer:'120.01',benaming:'Textielnijverheid uit het administratief arrondissement Verviers '},
    {nummer:'120.02',benaming:'Vlasbereiding'},
    {nummer:'120.03',benaming:'Handel in zakken in jute of in vervangingsmaterialen '},
    {nummer:'121',benaming:'Schoonmaak'},
    {nummer:'124',benaming:'Bouwbedrijf'},
    {nummer:'125',benaming:'Houtnijverheid'},
    {nummer:'125.01',benaming:'Bosontginningen'},
    {nummer:'125.02',benaming:'Zagerijen en aanverwante nijverheden'},
    {nummer:'125.03',benaming:'Houthandel '},
    {nummer:'126',benaming:'Stoffering en de houtbewerking'},
    {nummer:'127',benaming:'Handel in brandstoffen'},
    {nummer:'127.02',benaming:'Handl in brandstoffen in Oost-Vlaanderen'},
    {nummer:'128',benaming:'Huiden- en lederbedrijf en vervangingsproducten'},
    {nummer:'128.01',benaming:'Leerlooierij / handel in ruwe huiden en vellen'},
    {nummer:'128.02',benaming:'Schoeiselindustrie, de laarzenmakers en de maatwerkers'},
    {nummer:'128.03',benaming:'Marokijnwerk en de handschoennijverheid '},
    {nummer:'128.05',benaming:'Zadelmakerij, Riemen en industriële artikelen in leder'},
    {nummer:'128.06',benaming:'Orthopedische schoeisels'},
    {nummer:'129',benaming:'Voortbrenging van papierpap, papier en karton'},
    {nummer:'130',benaming:'Drukkerij-, grafische kunst- en dagbladbedrijf'},
    {nummer:'132',benaming:'Ondernemingen van technische land- en tuinbouwwerken'},
    {nummer:'133',benaming:'Tabaksbedrijf'},
    {nummer:'136',benaming:'Papier- en kartonbewerking'},
    {nummer:'139',benaming:'Binnenscheepvaart'},
    {nummer:'139.01',benaming:'Sleep-diensten'},
    {nummer:'140',benaming:'Vervoer'},
    {nummer:'140.04',benaming:'Grondafhandeling op luchthavens '},
    {nummer:'142',benaming:'Teruggewonnen grondstoffen opnieuw ter waarde brengen'},
    {nummer:'142.01',benaming:'Terugwinning van metalen'},
    {nummer:'142.02',benaming:'Terugwinning van lompen'},
    {nummer:'142.03',benaming:'Terugwinning van papier'},
    {nummer:'142.04',benaming:'Terugwinning van allerlei producten'},
    {nummer:'143',benaming:'Zeevisserij'},
    {nummer:'144',benaming:'Landbouw'},
    {nummer:'145',benaming:'Tuinbouwbedrijf'},
    {nummer:'146',benaming:'bosbouwbedrijf'},
    {nummer:'147',benaming:'Wapensmederij met de hand'},
    {nummer:'148',benaming:'Bont en kleinvel'},
    {nummer:'148.01',benaming:'Haarsnijderijen'},
    {nummer:'148.03',benaming:'Industriële en ambachtelijke fabricage van bontwerk'},
    {nummer:'148.05',benaming:'Pelslooierijen'},
    {nummer:'149',benaming:'Sectoren in de metaal- , machine- en elektrische bouw'},
    {nummer:'149.01',benaming:'Elektriciens: installatie en distributie'},
    {nummer:'149.02',benaming:'Koetswerk'},
    {nummer:'149.03',benaming:'Edele metalen'},
    {nummer:'149.04',benaming:'Metaalhandel'},
    {nummer:'150',benaming:'Pottengoed in potaarde'},
    {nummer:'152',benaming:'Gesubsidieerde inrichtingen van het vrij onderwijs'},
    {nummer:'200',benaming:'Bedienden (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'201',benaming:'Zelfstandige kleinhandel'},
    {nummer:'202',benaming:'Bedienden uit de kleinhandel in voedingswaren'},
    {nummer:'202.01',benaming:'Middelgrote levensmiddelenbedrijven'},
    {nummer:'203',benaming:'Bedienden uit de hardsteengroeven'},
    {nummer:'204',benaming:'Bedienden uit de porfiergroeven van het kanton van Lessen, Bierk-bij-Halle en Quenast'},
    {nummer:'205',benaming:'Bedienden van de steenkolenmijnen'},
    {nummer:'207',benaming:'Bedienden uit de scheikundige nijverheid'},
    {nummer:'209',benaming:'Bedienden der metaalfabrikantennijverheid'},
    {nummer:'210',benaming:'Bedienden van de ijzernijverheid'},
    {nummer:'211',benaming:'Bedienden uit de petroleumnijverheid en -handel'},
    {nummer:'214',benaming:'Bedienden van de textielnijverheid en het breiwerk'},
    {nummer:'215',benaming:'Bedienden van het kleding- en confectiebedrijf'},
    {nummer:'216',benaming:'Notarisbedienden'},
    {nummer:'217',benaming:'Casinobedienden'},
    {nummer:'218',benaming:'Bedienden (Besluitwet van 9 juni 1945 tot vastelling van het statuut der paritaire comités)'},
    {nummer:'219',benaming:'Erkende controleorganismen'},
    {nummer:'220',benaming:'Bedienden uit de voedingsnijverheid'},
    {nummer:'221',benaming:'Bedienden uit de papiernijverheid'},
    {nummer:'222',benaming:'Bedienden van de papier- en kartonbewerking'},
    {nummer:'223',benaming:'Sport'},
    {nummer:'224',benaming:'Bedienden van de non-ferro metalen'},
    {nummer:'225',benaming:'Bedienden van de inrichtingen van het gesubsidieerde vrij onderwijs'},
    {nummer:'226',benaming:'Bedienden uit de internationale handel, het vervoer en de aanverwante bedrijfstakken'},
    {nummer:'227',benaming:'Audiovisuele sector'},
    {nummer:'301',benaming:'Havenbedrijf'},
    {nummer:'301.01',benaming:'Haven van Antwerpen'},
    {nummer:'301.02',benaming:'Haven van Gent'},
    {nummer:'301.03',benaming:'Haven van Brussel en Vilvoorde'},
    {nummer:'301.04',benaming:'Haven van Oostende en Nieuwpoort'},
    {nummer:'301.05',benaming:'Haven van Zeebrugge'},
    {nummer:'301.06',benaming:'Haven van Brugge'},
    {nummer:'302',benaming:'Hotelbedrijf'},
    {nummer:'303',benaming:'Filmbedrijf'},
    {nummer:'303.01',benaming:'Filmproductie'},
    {nummer:'303.02',benaming:'Verdeling van films'},
    {nummer:'303.03',benaming:'Exploitatie van bioscoop-zalen'},
    {nummer:'303.04',benaming:'Technische filmbedrijvigheid'},
    {nummer:'304',benaming:'Vermakelijkheidsbedrijf'},
    {nummer:'305',benaming:'Gezondheidsdiensten'},
    {nummer:'305.01',benaming:'Privé-ziekenhuizen'},
    {nummer:'305.02',benaming:'Gezondheidsinrichtingen en -diensten'},
    {nummer:'305.03',benaming:'Tandprotheses'},
    {nummer:'306',benaming:'Verzekeringswezen'},
    {nummer:'307',benaming:'Makelarij en verzekeringsagentschappen'},
    {nummer:'308',benaming:'Maatschappijen voor hypothecaire leningen, sparen en kapitalisatie'},
    {nummer:'309',benaming:'Beursvennootschappen'},
    {nummer:'310',benaming:'Banken'},
    {nummer:'311',benaming:'Grote Kleinhandelszaken'},
    {nummer:'312',benaming:'Warenhuizen'},
    {nummer:'313',benaming:'Apotheken en tarificatiediensten'},
    {nummer:'314',benaming:'Kappersbedrijf en de schoonheidszorgen'},
    {nummer:'315',benaming:'Handelsluchtvaart'},
    {nummer:'315.01',benaming:'Luchtvaartmaatschappij SABENA'},
    {nummer:'315.02',benaming:'Luchtvaartmaatschappijen ander dan de N.V. SABENA'},
    {nummer:'316',benaming:'Koopvaardij'},
    {nummer:'317',benaming:'Bewakings- en/of toezichtsdiensten '},
    {nummer:'318',benaming:'Gezins- en bejaardenhulp'},
    {nummer:'318.02',benaming:'Diensten voor gezins- en bejaardenhulp van de Vlaamse Gemeenschap'},
    {nummer:'319.01',benaming:'Opvoedings- en huis-vestingsinrichtingen + –diensten van de Vlaamse Gemeenschap '},
    {nummer:'319',benaming:'Opvoedings- en huisvestingsinrichtingen en -diensten'},
    {nummer:'319.01',benaming:'Opvoedings- en huisvestingsinrichtingen en -diensten van de Vlaamse Gemeenschap'},
    {nummer:'319.02',benaming:'Opvoedings- en huis-vestingsinrichtingen + –diensten van Franse en Waalse gewest/ Duitse gemeenschap'},
    {nummer:'320',benaming:'Begrafenisondernemingen'},
    {nummer:'321',benaming:'Groothandelaars-verdelers in geneesmiddelen '},
    {nummer:'322',benaming:'Uitzendarbeid en de erkende ondernemingen die buurtwerken of -diensten leveren'},
    {nummer:'322.01',benaming:'Erkende ondernemingen die buurtwerken of -diensten leveren'},
    {nummer:'323',benaming:'Beheer van gebouwen en de dienstboden'},
    {nummer:'324',benaming:'Diamantnijverheid en  handel'},
    {nummer:'324.01',benaming:'Diamantzagen'},
    {nummer:'324.02',benaming:'Kleinbranche in de diamantnijverheid en -handel'},
    {nummer:'324.03',benaming:'Vakopleiding in de diamantnijverheid en -handel'},
    {nummer:'325',benaming:'Openbare kredietinstellingen'},
    {nummer:'326',benaming:'Gas- en elektriciteitsbedrijf'},
    {nummer:'327',benaming:'Beschutte werkplaatsen en de sociale werkplaatsen'},
    {nummer:'327.01',benaming:'Beschutte werkplaatsen gesubsidieerd door de Vlaamse Gemeenschap'},
    {nummer:'327.02',benaming:'Beschutte werkplaatsen gesubsideerd door de Franse Gemeenschapscommissie'},
    {nummer:'327.03',benaming:'Beschutte werkplaatsen van het Waalse Gewest en van de Duitstalige Gemeenschap '},
    {nummer:'328',benaming:'Stads- en streekvervoer'},
    {nummer:'328.01',benaming:'Stads- en streekvervoer in het Vlaamse Gewest'},
    {nummer:'328.02',benaming:'Stads- en streekvervoer in het Waalse Gewest'},
    {nummer:'328.03',benaming:'Stads- en streekvervoer in het Brusselse Hoofdstedelijk Gewest'},
    {nummer:'329',benaming:'Socio-culturele sector'},
    {nummer:'329.01',benaming:'Socio-culturele sector van de Vlaamse Gemeenschap (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'329.02',benaming:'Socio-culturele sector van de Franstalige en Duitstale Gemeenschap (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'329.03',benaming:'Federale en bicommunautaire socio-culturele organisaties (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'330',benaming:'Gezondheidsinrichtingen en -diensten'},
    {nummer:'331',benaming:'Vlaamse welzijns- en gezondheidssector (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'332',benaming:'Franstalige, duitstalige en bicommunautaire welzijns- en gezondheidssector (niet samengesteld, (onder)voorzitter/leden niet benoemd)'},
    {nummer:'333',benaming:'Toeristische attracties'},


]

export interface OpzegtermijnItem {
    //nummer van paritair commité
    index: string | number | null;
    //hoeveel maanden werkt men in het bedrijf
    ancieniteit: number | Date | null;
    //opzegtermijn
    periode: number;
  }


  //Tabellen voor berekening Werkgever
  //Arbeiders contracten voor 01/01/2012
  //Periode in Dagen
  export const tabel1: OpzegtermijnItem[] = [

    // {index: null , ancieniteit: 9999,periode: 112},
    {index: null , ancieniteit: 241,periode: 112},
    {index: null , ancieniteit: 181,periode: 84},
    {index: null, ancieniteit: 121,periode: 56},
    {index: null , ancieniteit: 61,periode: 42},
    {index: null , ancieniteit: 6,periode: 35},
    {index: null , ancieniteit: 0,periode: 28},

    // {index: "109" , ancieniteit: 9999,periode: 64},
    {index: "109" , ancieniteit: 241,periode: 64},
    {index: "109" , ancieniteit: 0,periode: 32},
    // {index: "124" , ancieniteit: 9999,periode: 32},
    {index: "124" , ancieniteit: 241,periode: 56},
    {index: "124" , ancieniteit: 37,periode: 28},
    {index: "124" , ancieniteit: 6,periode: 14},
    {index: "124" , ancieniteit: 0,periode: 3},

    // {index: "126" , ancieniteit: 9999,periode: 112},
    {index: "126" , ancieniteit: 241,periode: 112},
    {index: "126" , ancieniteit: 0,periode: 28},

    // {index: "128.01" , ancieniteit: 9999,periode: 64},
    {index: "128.01" , ancieniteit: 241,periode: 64},
    {index: "128.01" , ancieniteit: 121,periode: 48},
    {index: "128.01" , ancieniteit: 0,periode: 32},

    // {index: "128.02" , ancieniteit: 9999,periode: 64},
    {index: "128.02" , ancieniteit: 241,periode: 64},
    {index: "128.02" , ancieniteit: 0,periode: 32},
    // {index: "140.04" , ancieniteit: 9999,periode: 120},
    {index: "140.04" , ancieniteit: 121,periode: 120},
    {index: "140.04" , ancieniteit: 61,periode: 90},
    {index: "140.04" , ancieniteit: 37,periode: 60},
    {index: "140.04" , ancieniteit: 0,periode: 28},
    // {index: "142.02" , ancieniteit: 9999,periode: 112},
    {index: "142.02" , ancieniteit: 241,periode:112},
    {index: "142.02" , ancieniteit: 61,periode: 42},
    {index: "142.02" , ancieniteit: 0,periode: 28},
    // {index: "147" , ancieniteit: 9999,periode: 128},
    {index: "147" , ancieniteit: 241,periode: 128},
    {index: "147" , ancieniteit: 121,periode: 64},
    {index: "147" , ancieniteit: 0,periode: 32},

    // {index: "301.01" , ancieniteit: 9999,periode: 64},
    {index: "301.01" , ancieniteit: 241,periode: 64},
    {index: "301.01" , ancieniteit: 0,periode: 32},

    // {index: "311" , ancieniteit: 9999,periode: 129},
    {index: "311" , ancieniteit: 241,periode: 129},
    {index: "311" , ancieniteit: 121,periode: 64},
    {index: "311" , ancieniteit: 61,periode: 48},
    {index: "311" , ancieniteit: 6,periode: 40},
    {index: "311" , ancieniteit: 0,periode: 28},

    // {index: "324" , ancieniteit: 9999,periode: 28},
    {index: "324" , ancieniteit: 241,periode: 28},
    {index: "324" , ancieniteit: 121,periode: 14},
    {index: "324" , ancieniteit: 0,periode: 7},

    // {index: "330" , ancieniteit: 9999,periode: 70},
    {index: "330" , ancieniteit: 241,periode: 70},
    {index: "330" , ancieniteit: 121,periode: 35},
    {index: "330" , ancieniteit: 0,periode: 28},
  ]

  //Arbeiders contracten Na 01/01/2012 en voor 01/01/2014
  //Periode in dagen
  export const tabel2: OpzegtermijnItem[] = [

    // {index: null , ancieniteit: 9999,periode: 129},
    {index: null , ancieniteit: 241,periode: 129},
    {index: null , ancieniteit: 181,periode: 97},
    {index: null, ancieniteit: 121,periode: 64},
    {index: null , ancieniteit: 61,periode: 48},
    {index: null , ancieniteit: 6,periode: 40},
    {index: null , ancieniteit: 0,periode: 28},
  
    // {index: "109" , ancieniteit: 9999,periode: 64},
    {index: "109" , ancieniteit: 241,periode: 64},
    {index: "109" , ancieniteit: 0,periode: 32},
   
    // {index: "124" , ancieniteit: 9999,periode: 64},
    {index: "124" , ancieniteit: 241,periode: 64},
    {index: "124" , ancieniteit: 37,periode: 32},
    {index: "124" , ancieniteit: 6,periode: 16},
    {index: "124" , ancieniteit: 0,periode: 4},

    // {index: "126" , ancieniteit: 9999,periode: 128},
    {index: "126" , ancieniteit: 241,periode: 128},
    {index: "126" , ancieniteit: 0,periode: 32},

    // {index: "128.01" , ancieniteit: 9999,periode: 64},
    {index: "128.01" , ancieniteit: 241,periode: 64},
    {index: "128.01" , ancieniteit: 121,periode: 48},
    {index: "128.01" , ancieniteit: 0,periode: 32},
  
    // {index: "128.02" , ancieniteit: 9999,periode: 64},
    {index: "128.02" , ancieniteit: 241,periode: 64},
    {index: "128.02" , ancieniteit: 0,periode: 32},

    // {index: "140.04" , ancieniteit: 9999,periode: 120},
    {index: "140.04" , ancieniteit: 121,periode: 120},
    {index: "140.04" , ancieniteit: 61,periode: 90},
    {index: "140.04" , ancieniteit: 37,periode: 60},
    {index: "140.04" , ancieniteit: 6,periode: 32},
    {index: "140.04" , ancieniteit: 0,periode: 28},
   
    // {index: "142.02" , ancieniteit: 9999,periode: 129},
    {index: "142.02" , ancieniteit: 241,periode: 129},
    {index: "142.02" , ancieniteit: 61,periode: 48},
    {index: "142.02" , ancieniteit: 6,periode:32},
    {index: "142.02" , ancieniteit: 0,periode:28},

    // {index: "147" , ancieniteit: 9999,periode: 128},
    {index: "147" , ancieniteit: 241,periode: 128},
    {index: "147" , ancieniteit: 121,periode: 64},
    {index: "147" , ancieniteit: 0,periode: 32},
 
    // {index: "301.01" , ancieniteit: 9999,periode: 64},
    {index: "301.01" , ancieniteit: 241,periode: 64},
    {index: "301.01" , ancieniteit: 0,periode: 32},

    // {index: "311" , ancieniteit: 9999,periode: 129},
    {index: "311" , ancieniteit: 241,periode:129},
    {index: "311" , ancieniteit: 121,periode: 64},
    {index: "311" , ancieniteit: 61,periode: 48},
    {index: "311" , ancieniteit: 6,periode: 40},
    {index: "311" , ancieniteit: 0,periode: 28},

    // {index: "324" , ancieniteit: 9999,periode: 32},
    {index: "324" , ancieniteit: 241,periode: 32},
    {index: "324" , ancieniteit: 121,periode: 16},
    {index: "324" , ancieniteit: 0,periode: 8},
  
    // {index: "330" , ancieniteit: 9999,periode: 80},
    {index: "330" , ancieniteit: 241,periode: 80},
    {index: "330" , ancieniteit: 121,periode: 40},
    {index: "330" , ancieniteit: 6,periode: 32},
    {index: "330" , ancieniteit: 0,periode: 28},

  
  ]

  //Bedienden contracten na 01/01/2013
  //Periode in weken
  export const tabel4: OpzegtermijnItem[] = [
    {index: null , ancieniteit: 9999,periode:66 },
    {index: null , ancieniteit: 289,periode:66 },
    {index: null , ancieniteit: 277,periode:65},
    {index: null , ancieniteit: 265,periode:64 },
    {index: null , ancieniteit:253 ,periode:63 },
    {index: null , ancieniteit:241 ,periode:62 },
    {index: null , ancieniteit:229 ,periode:60 },
    {index: null , ancieniteit:217 ,periode:57 },
    {index: null, ancieniteit: 205,periode:54 },
    {index: null , ancieniteit: 193,periode:51 },
    {index: null , ancieniteit: 181,periode: 48},
    {index: null , ancieniteit: 169,periode: 45},
    {index: null , ancieniteit: 157,periode: 42},
    {index: null , ancieniteit:145 ,periode:39 },
    {index: null, ancieniteit:133 ,periode:36 },
    {index: null , ancieniteit:121 ,periode:33 },
    {index: null , ancieniteit:109 ,periode:30 },
    {index: null , ancieniteit:97 ,periode:27 },
    {index: null, ancieniteit: 85,periode:24 },
    {index: null , ancieniteit: 73,periode:21 },
    {index: null , ancieniteit: 61,periode:18 },
    {index: null , ancieniteit: 49,periode:15 },
    {index: null , ancieniteit: 37,periode:13 },
    {index: null , ancieniteit:25 ,periode:12 },
    {index: null, ancieniteit:22 ,periode:11 },
    {index: null , ancieniteit: 19,periode:10 },
    {index: null , ancieniteit:16 ,periode:9 },
    {index: null , ancieniteit:13 ,periode: 8},
    {index: null , ancieniteit:10 ,periode: 7},
    {index: null , ancieniteit:7 ,periode:6 },
    {index: null , ancieniteit:6 ,periode:5 },
    {index: null, ancieniteit: 5,periode:4 },
    {index: null , ancieniteit:4 ,periode:3 },
    {index: null , ancieniteit:0 ,periode:1 },
  ]


   //OPZEG WERKNEMER
   //Arbeiders contracten voor 01/01/2014
  //Periode in dagen
  export const tabel5: OpzegtermijnItem[] = [
    // {index: null , ancieniteit:9999 ,periode:28 },
    {index: null , ancieniteit:241 ,periode:28 },
    {index: null , ancieniteit:0 ,periode:14 },
    // {index: "124" , ancieniteit:9999 ,periode:28},
    {index: "124" , ancieniteit:241 ,periode:28 },
    {index: "124", ancieniteit:121,periode:14 },
    {index: "124", ancieniteit:0,periode:7 },

    // {index: "142.02" , ancieniteit:9999,periode:56},
    {index: "142.02" , ancieniteit:241 ,periode:56 },
    {index: "142.02" , ancieniteit:61 ,periode:21},
    {index: "142.02" , ancieniteit:0,periode:14},

    {index: "324", ancieniteit:1 ,periode:2 },
    {index: "324", ancieniteit:0 ,periode:2 },

   
  ]


    //Bedienden contracten voor 01/01/2014
    //Periode in weken
  export const tabel6: OpzegtermijnItem[] = [
    {index: "3", ancieniteit:1971,periode: 6},
    {index: "3" , ancieniteit:2003,periode:4.5},
    {index: "3" , ancieniteit:2008 ,periode:3 },
    {index: "3" , ancieniteit:2014 ,periode:13 },

    {index: "2" , ancieniteit:1971 ,periode:4.5},
    {index: "2", ancieniteit:2003 ,periode:4.5},
    {index: "2", ancieniteit:2008 ,periode:3 },
    {index: "2" , ancieniteit:2014 ,periode:13 },

    {index: "1", ancieniteit:1971,periode:3 },
    {index: "1" , ancieniteit:2003 ,periode:3 },
    {index: "1" , ancieniteit:2008 ,periode:3 },
    {index: "1" , ancieniteit:2014 ,periode:13 },

  ]
    //Bedienden contracten na 31/12/2013
  //Periode in weken
  export const tabel7: OpzegtermijnItem[] = [
    {index: null , ancieniteit:9999 ,periode:13 },
    {index: null , ancieniteit:97 ,periode:13 },
    {index: null, ancieniteit: 85,periode:12},
    {index: null , ancieniteit: 73,periode:10 },
    {index: null , ancieniteit: 61,periode:9 },
    {index: null , ancieniteit: 49,periode:7 },
    {index: null , ancieniteit: 25,periode:6 },

    {index: null , ancieniteit:22 ,periode:5 },
    {index: null, ancieniteit:19 ,periode:5},
    {index: null , ancieniteit: 16,periode:4 },
    {index: null , ancieniteit:13 ,periode:4 },
    {index: null , ancieniteit:10 ,periode: 3},
    {index: null , ancieniteit:7 ,periode: 3},

    {index: null , ancieniteit:6 ,periode:2 },
    {index: null, ancieniteit: 5,periode:2 },
    {index: null , ancieniteit:4 ,periode:1 },
    {index: null , ancieniteit:0 ,periode:1 },
  ]